import Ajv from 'ajv';
import CodeMirror, { Annotation } from 'codemirror';
import jp2p from 'jp2p';
import JSONLint from 'json-lint';
import _ from 'lodash';

export function validateJsonStructure(text: string): Annotation[] {
  const lint = JSONLint(text, { comments: false });

  if (!lint.error) {
    return [];
  }

  return [
    {
      from: CodeMirror.Pos(lint.line - 1, lint.character - 1),
      to: CodeMirror.Pos(lint.line - 1, lint.character),
      message: lint.error,
    },
  ];
}

export function validateJsonSchema(text: string, schema: object): Annotation[] {
  const jsonObj = JSON.parse(text);
  const ajv = new Ajv();
  const validate = ajv.compile(schema);
  const valid = validate(jsonObj);

  if (valid || !validate.errors) {
    return [];
  }

  const error = validate.errors[0];

  let linePosition;
  try {
    linePosition = jp2p.getLineNumber(text, error.instancePath);
  } catch (e) {
    linePosition = { line: 1, column: 1 };
  }

  return [
    {
      from: CodeMirror.Pos(linePosition.line - 1, linePosition.column - 1),
      to: CodeMirror.Pos(linePosition.line - 1, linePosition.column),
      message: _.capitalize(error.message),
    },
  ];
}
